/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IBloodTypeClass } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IExclusionsProps {
	data: IBloodTypeClass
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IExclusionsState {}

export class ExclusionsComponent extends React.Component<IExclusionsProps, IExclusionsState> {
	constructor(props: Readonly<IExclusionsProps>) {
		super(props)
	}

	render(): React.ReactNode {
		let row = ''
		const exclusionsModel = this.props.data

		exclusionsModel.exclusions.forEach(element => {
			row += row.length > 0 ? '<br />' : ''
			row += CommonUtils.DateRange(element.startDate, element.endDate, true) + (element.quantityQualifier == null ? '' : element.quantityQualifier) + ' Remaining: <strong>' + element.remaining + '</strong>'
		})

		if (exclusionsModel.exclusions.length > 0) {
			return (
				<tr>
					<td>Exclusions:</td>
					<td colSpan={3}>{parse(row)}</td>
				</tr>
			)
		}

		return ''
	}
}
